<template>
  <el-dialog
    title="开启评卷"
    width="820px"
    @open="initData"
    :close-on-click-modal="false"
    :visible.sync="visible"
    :before-close="handleCancel">
    <div class="reopen-wrap" v-if='isRegular'>
      <select-mark-item ref="select-mark-item" :examId='examId' :subject='{subjectId,subjectName}' :markItems='itemStatus' :type="true"/>
    </div>
    <table v-else class="check-item-table">
      <tr>
        <td colspan="3" class="check-subject-header">科目：<span class="subject-name">{{subjectName}}</span></td>
      </tr>
      <tr class="check-item-row">
        <td rowspan="5" class="check-label-wrapper"><span class="check-label">评卷前检查项</span></td>
      </tr>
      <tr class="check-item-row">
        <td><span class="check-label-span">1. 收集题卡信息</span></td>
        <td v-if="workItemStatus[0]"><span class="check-tip success-tip"><i class="el-icon-circle-check check-pass"></i><span>完成</span></span></td>
        <td v-else>
          <span class="check-tip error-tip" v-if="typeof workItemStatus[0] !== 'undefined'">
            <i class="iconfont icon-jinggao-copy check-fail"></i>
            <span class="fail-label">到首页“待处理”把该工作项完成才能开启评卷。</span>
          </span>
        </td>
      </tr>
      <tr class="check-item-row">
        <td><span class="check-label-span">2. 设评卷方案</span></td>
        <td v-if="workItemStatus[1]"><span class="check-tip success-tip"><i class="el-icon-circle-check check-pass"></i><span>完成</span></span></td>
        <td v-else>
          <span class="check-tip error-tip" v-if="typeof workItemStatus[1] !== 'undefined'">
            <i class="iconfont icon-jinggao-copy check-fail"></i>
            <span class="fail-label">到首页“待处理”把该工作项完成才能开启评卷。</span>
          </span>
        </td>
      </tr>
      <tr class="check-item-row">
        <td><span class="check-label-span">3. 分评卷任务</span></td>
        <td v-if="workItemStatus[2]"><span class="check-tip success-tip"><i class="el-icon-circle-check check-pass"></i><span>完成</span></span></td>
        <td v-else>
          <span class="check-tip warn-tip" v-if="typeof workItemStatus[2] !== 'undefined'">
            <i class="iconfont icon-jinggao-copy check-warn"></i>
            <span class="warn-label">未完成</span>
          </span>
        </td>
      </tr>
      <tr class="check-item-row">
        <td><span class="check-label-span">4. 扫描上传答题卡</span></td>
        <td v-if="workItemStatus[3]"><span class="check-tip success-tip"><i class="el-icon-circle-check check-pass"></i><span>完成</span></span></td>
        <td v-else>
          <span class="check-tip error-tip" v-if="typeof workItemStatus[3] !== 'undefined'">
            <i class="iconfont icon-jinggao-copy check-fail"></i>
            <span class="fail-label">上传答题卡数量为0（无卷可评）不能开启评卷。请督促答题卡扫描上传工作。</span>
          </span>
        </td>
      </tr>
    </table>
    <span slot="footer">
      <el-button v-if="!isRegular" type="success" @click="handleNext">{{confirmLabel}}</el-button>
      <el-button type="info" @click="handleCancel">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {queryExamMonitor} from '@/model/exam-manager-model'
import {getItemInfo} from '@/model/item-model'
import SelectMarkItem from '@/views/exam/open-pre-mark/SelectMarkItem'
import {assignPJVM, changePjStatus} from '@/model/pj-server-model'
import {queryScanProgressSummary} from '@/model/monitor-scan-model'
import common from '@/util/common'

export default {
  name: 'OpenPreMark',
  components: {
    SelectMarkItem
  },
  props: {
    subjectId: {
      type: String,
      required: true
    },
    examId: {
      type: String,
      required: true
    },
    subjectName: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    userInfo () {
      return common.getUserInfo()
    }
  },
  data () {
    return {
      // 确认按钮文本  '我知道了'、'去开启试评'
      confirmLabel: '我知道了',
      // 0:未完成，1：完成
      workItemStatus: [],
      // 题目列表
      // items: []
      items: [],
      itemNames: [],
      itemStatus: [],
      isRegular: false
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      // todo: 查询考试科目是否是纯客观题，若是则返回主页面  getItemStructure

    // 查询考试科目的工作项状态（导入考生，收集题卡信息，设评卷方案，分评卷任务，扫描上传答题卡数量），更改confirmLabel,workItemStatus
      let param1 = {examId: this.examId, subjectName: this.subjectName}
      queryExamMonitor(param1).then(res => {
        let monitorItems = res.data.find(item => {
          return item.subjectId === this.subjectId
        }).monitorItems
        // [..., ["导入考生", 0, "未开始", [["数学", 0]], ...]
        this.workItemStatus.push(common.checkFinish(monitorItems[5]),
          common.checkFinish(monitorItems[6]),
          common.checkFinish(monitorItems[1]))
        // 判断评卷状态
        for (let monitorItem of monitorItems) {
          if (monitorItem.monitorName === '开启正评/重评') {
            this.isRegular = parseInt(monitorItem.monitorProcess) === 1
            this.getItemsInfo()
          }
        }
      }).then(() => {
        let param2 = {data: {examId: this.examId, subjectId: this.subjectId, orgId: this.userInfo.origanization}}
        queryScanProgressSummary(param2).then(res => {
          let status = res.data && res.data.upload.done > 0 ? 1 : 0
          this.workItemStatus.push(status)
          this.updateConfirmLabel()
        })
      }).catch(e => {
        console.log(e)
        this.alertError('网络异常，请稍后重试')
      })
    },
    getItemsInfo () {
      getItemInfo({
        data: {
          examId: this.examId,
          subjectId: this.subjectId
        }
      }).then((res) => {
        if (res.result.toString() === 'true') {
          for (let item of res.data) {
            if (item.type === 'zg') {
              this.itemNames.push(item.name)
            }
          }
          this.getItemStatus()
          //
        } else {
          this.$message.error('获取题目信息失败.')
        }
      })
    },
    getItemStatus () {
      let param = {
        examId: this.examId,
        subjectId: this.subjectId,
        divId: this.itemNames,
        status: ''
      }
      changePjStatus(param).then(pjRes => {
        if (pjRes.result !== 'false') {
          pjRes.map(itemStatus => {
            this.itemStatus = pjRes
          })
        } else {
          if (pjRes.errCode !== 'NoExamSubjectResource' && pjRes.errDesc.indexOf('Cannot determine target DataSource') === -1) {
            this.alertError(pjRes.errDesc || '获取题目信息失败')
          } else {
            console.log(pjRes.errDesc)
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * 处理下一步按钮点击事件
     * “我知道了” → 跳转到首页；“去开启试评” → 显示试评题目列表
     */
    handleNext () {
      switch (this.confirmLabel) {
        case '我知道了':
          this.$emit('dialog-close', {})
          // this.itemToMarkVisible = true
          break
        case '开启评卷':
          // this.itemToMarkVisible = true
          let param = {examId: this.examId, subjectId: this.subjectId}

          assignPJVM(param).then((pvmResult) => {
            console.log(pvmResult)
            if (pvmResult.result === 'true') {
              // 获取评卷单元地址
              this.openMark()
            } else {
              this.alertError(pvmResult.errDesc || '开启评卷失败')
            }
          })
      }
    },
    openMark () {
      this.submitLoading = true
      let param = {
        examId: this.examId,
        subjectId: this.subjectId,
        divId: this.itemNames,
        status: 'regular'
      }
      changePjStatus(param).then(pjRes => {
        this.submitLoading = false
        if (pjRes.length > 0) {
          this.alertSuccess('您已经成功开启正式评卷！')
        } else {
          if (pjRes.errDesc.indexOf('Cannot determine target DataSource') === -1) {
            this.alertError(pjRes.errDesc || '开启正试评卷失败，请稍后再试！')
          } else {
            console.log(pjRes.errDesc)
          }
        }
      }).catch(err => {
        console.log(err)
        this.alertError('开启正试评卷失败，请稍后再试！')
        this.submitLoading = false
      })
    },
    /**
     * 处理取消弹窗点击事件
     * 弹出页面改动将不会提交的提示，确定则返回首页
     */
    handleCancel () {
      this.$confirm('取消返回将不会保存页面上的修改，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('dialog-close', {})
      })
    },

    // 更新确认按钮文本
    updateConfirmLabel () {
      let items = this.workItemStatus.slice() // 复制一份
      items[3] = 1 // 第四项不是必须项，故设为完成
      let arr = items.filter(val => val === 0)
      if (arr.length === 0) {
        this.confirmLabel = '开启评卷'
      }
    },

    /**
     * 错误弹窗
     *
     */
    alertError (errorMsg) {
      const h = this.$createElement
      let tipEls = [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--warning`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--warning']
        }, errorMsg)
      ]
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, tipEls)
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        confirmButtonClass: 'kw-alert__confirm-button kw-alert__confirm-button--success'
      })
    },

    // 成功弹窗
    alertSuccess (msg) {
      const h = this.$createElement
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--success`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--success']
        }, msg)
      ])
      this.$alert(vnode, '', {
        confirmButtonText: '确定',
        center: true,
        showClose: false,
        showCancelButton: false,
        callback: action => {
          this.$emit('dialog-close', {examId: this.examId, operate: 'updateTaskMonitor'})
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.check-item-table{
  border-collapse: collapse;
  border: 1px solid #d8d8c9;
  td{
    border: 1px solid #d8d8c9;
  }

  .check-subject-header{
    padding: 15px 25px;
  }

  .subject-name{
    font-weight: bold;
    color: #000;
  }

  .check-item-row{
    td{
      border:none;
      border-top: 1px solid #d8d8c9;
      // padding: 36px 0 36px 54px;
      height: 86px;
      padding-left: 30px;
    }
    .check-label-wrapper{
      padding: 0;
      width: 100px;
      text-align: center;
      vertical-align: middle;
      border: 1px solid #d8d8c9;
    }
    .check-label{
      display: inline-block;
      width: 20px;
      line-height: 28px;
    }

  }
  .check-label-span{
    display: inline-block;
    width: 145px;
  }
  .check-tip{
    display: inline-block;
    width: 460px;
  }

  .success-tip{
    color: #5eb388;
  }

  .check-pass{
    font-size: 19px;
    vertical-align: text-bottom;
    margin-right: 4px;
  }

  .check-fail{
    margin-right: 4px;
    font-size: 22px;
    vertical-align: middle;
    color: #ff0303;
  }

  .error-tip{
    color: #ff0000;
  }

  .fail-label{
    padding: 4px 6px;
    border: 1px solid #ff0303;
    border-radius: 4px;
    font-size: 12px;
  }

  .warn-tip{
    color: #ff8f17;
  }

  .check-warn{
    margin-right: 4px;
    font-size: 22px;
    vertical-align: middle;
    color: #ff8f17;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exam/open-mark/OpenMarkForSchool.vue